/**
 * Command history for CTA-608.
 *
 * @group CTA-608
 * @beta
 */
export type CmdHistory = {
	a: number | null;
	b: number | null;
};
